export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENTID as string,
    authority: process.env.REACT_APP_AZURE_AUTHORITY as string,
    redirectUri: '/',
  },
};
